$(document).ready(function()
{
    DynaBase_Tabs.init();

    $(document).ajaxStart(function() {
        if($('.alert_item.information').length == 0) {
            DynaBase_Overlay.show();
        }
    });
    $(document).ajaxStop(function() {
        DynaBase_Overlay.hide();
    });

    // Presmerovani v pripade neplatnych dat (vyprseni cache)
    $(document).ajaxComplete(function(event, jqXHR) {
        if ('application/json' == jqXHR.getResponseHeader('Content-Type')) {
            var json = jqXHR.responseText;
            var json = JSON && JSON.parse(json) || $.parseJSON(json);

            if (typeof(json.invalidDataUrl) != "undefined") {
                window.location.href = json.invalidDataUrl;
            }
        }
    });

    // Modalni okno potvrzujici smazani
    $('#page-header-buttons, table.ui-jqgrid-btable')
        .off('click', '.dialog-delete')
        .on('click', '.dialog-delete', function(e) {
        e.preventDefault();

        var url = $(this).attr('href');

        Lemo_Modal.setTitle(translate('Delete'));
        Lemo_Modal.setContent('<p class="text">' + translate('Do you really want to delete selected item?') + '</p>');
        Lemo_Modal.addButton('delete', '<i class="fas fa-fw fa-trash"></i> ' + translate('Delete'), 'btn btn-danger', function() {
            DynaBase_Overlay.show();
            window.location.href = url
        });
        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function() {
            Lemo_Modal.close();
        });
        Lemo_Modal.build();

        return false;
    });

    $.extend($.fn.datetimepicker.defaults, {
        format: 'L',
        icons: {
            time: "fas fa-clock",
            date: "fas fa-calendar-alt",
            up: "fas fa-arrow-up",
            down: "fas fa-arrow-down",
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-dot-circle',
            clear: 'fas fa-trash'
        },
        daysOfWeekDisabled : []
    });

    // Zarovnani strankovani doprostred gridu
    $('div.ui-jqgrid').find('td[id$="_pager_left"]').each(function(i, element) {
        $(element).removeAttr('style');
    });

    // Zobrazeni Overlay na odeslání formuláře
    var form = $('form');
    if(form.length) {
        form.on('submit', function() {
            DynaBase_Overlay.show();
        });
    }
});

function translate(t)
{
    if(t && typeof language[t] !== 'undefined') {
        return language[t];
    } else {
        return t;
    }
}
